export default () => ({
  debt: [],
  debtCardSummary: {
    long: {
      label: 'Deuda largo plazo SBIF',
      value: '$ 0,00'
    },
    short: {
      label: 'Deuda corto plazo SBIF',
      value: '$ 0,00'
    }
  },
  debtSummary: {
    totalMonthlyDebt: '$ 0,00'
  },
  debtor: {},
  eligibility: {},
  eligibilityType: {},
  eligibilityData: {},
  eligibilityParams: {},
  eligibilityResult: {},
  eligibilityContext: {
    country: 'CL',
    segment: 'SUBSIDY',
    classification: 'IMMEDIATE',
    type: 'current'
  },
  idNumber: '',
  income: {},
  incomeCardSummary: {
    income: {
      label: 'Renta bruta',
      value: '$ 0,00',
      isBold: true,
      children: [
        {
          label: 'Monto Liquido',
          value: '$ 0,00'
        },
        {
          label: 'Montos fijos no imponibles (colación, movilización)',
          value: '$ 0,00'
        },
        {
          label: 'Montos variables imponibles periódicos (bonos)',
          value: '$ 0,00'
        }
      ]
    },
    discount: {
      label: 'Descuentos',
      value: '$ 0,00',
      isBold: true,
      children: [
        {
          label: 'Descuentos legales',
          value: '$ 0,00'
        },
        {
          label: 'Otros descuentos',
          value: '$ 0,00'
        }
      ]
    }
  },
  incomeSummary: {
    totalFixed: 0,
    totalIncome: '$ 0,00',
    totalIncomeUf: 'UF 0,00',
    totalVariable: 0
  },
  manualEvaluationId: null,
  parentEvaluationId: '',
  simulation: {
    generalParams: {
      country: 'CL',
      creditType: '',
      ufDate: '',
      purchaseDate: '',
      insuranceableValue: 0,
      hasRealEstate: false,
      hasAddress: false
    }
  },
  totalDebtCardSummary: '$ 0,00',
  totalIncomeCardSummary: '$ 0,00',
  userId: '',
  evaluationType: null
});
